import $ from 'jquery';
import { prepareMiniLightBox } from "./component/mini-lightbox/mini-lightbox-configure";

export	function initInfiniteScroll(){

	let viewPortHeight;
	// let newsStoryNumber =1;
	const scrollSelector = document; //".l-pageContainer";

	if($(".js-infiniteScroll").length>0){
		const nextSelector = $(".js-infiniteScroll");
		viewPortHeight = $(window).height();
		$(window).resize(function() {
			viewPortHeight = $(window).height();
		});
		$(scrollSelector).bind("scroll",function(){
			infiniteScrollHandler(nextSelector);
		});
		$(nextSelector).bind("click",function(event){
			nextPage(this);
			event.stopPropagation();
			event.preventDefault();
		});
	}


	function infiniteScrollHandler(){

		const infiniteScrollElements = $(".js-infiniteScroll");//document.querySelector(".js-infiniteScroll").getBoundingClientRect();
		for(let i=0;i<infiniteScrollElements.length;i++){
			if(infiniteScrollElements[i].getBoundingClientRect().top<= (viewPortHeight-$(".l-pageFooter").outerHeight()))	{
				nextPage(infiniteScrollElements[i]);
			}
		};
	};

	function nextPage(nextSelector){
		$(nextSelector).find(".infiniteScroll-loader").show();
		$(nextSelector).find(".infiniteScroll-nextpage").hide();

		$(scrollSelector).unbind('scroll');
		const href = $(nextSelector).attr("href");
		let route=$(nextSelector).attr("data-page-route");
		if(route.substr(-1,1) !== "/");{
			route += "/";
		}

		const pg = parseInt(href.replace(route,""));
		$.get(href, function( data ) {
			$(nextSelector).before(data);//.parent().append(data );

			$(nextSelector).find(".infiniteScroll-loader").hide();
			const totalPages = 0 + $(nextSelector).attr("data-page-count");
			if(pg<totalPages){
				$(nextSelector).attr("href",href.replace(pg,pg+1));
				$(nextSelector).find(".infiniteScroll-nextpage").show();
				$(scrollSelector).bind("scroll",function(){
					infiniteScrollHandler(nextSelector);
				});
			}
			prepareMiniLightBox();
		});
	};

}